import { render, staticRenderFns } from "./data_sort.vue?vue&type=template&id=e70a928c&scoped=true"
import script from "./data_sort.vue?vue&type=script&lang=js"
export * from "./data_sort.vue?vue&type=script&lang=js"
import style0 from "./data_sort.vue?vue&type=style&index=0&id=e70a928c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70a928c",
  null
  
)

export default component.exports